export const getTextFields = (userData: any) => [
  {
    id: "user-fullname",
    name: "fullName",
    label: "Full Name",
    type: "text",
    placeholder: "Enter Full Name",
    required: true,
    capitalizedFirst: true,
    value: userData?.fullName || "",
  },
  {
    id: "user-phone",
    name: "phone",
    label: "Phone",
    type: "text",
    placeholder: "Enter Phone",
    required: true,
    value: userData?.phone || "",
  },
  {
    id: "user-email",
    name: "email",
    label: "Email Address",
    type: "text",
    placeholder: "Enter Email Address",
    required: true,
    disabled: true,
    value: userData?.email || "",
  },
    // {
    //     label: "Role",
    //     value: userData?.userRole?.map((data : any)=> data?.role?.name),
    //     formField: false,
    // },
      {
    label: "Role",
    value: userData?.user?.role?.name || "Undefined",
    formField: false,
  },
  {
    label: "Gender",
    value: userData?.gender || "Undefined",
    formField: false,
  },
  {
    id: "user-password",
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Enter Password",
    required: true,
    formField: Object.keys(userData || {}).length > 0 ? false : true,
    value: null,
  },
];